import { useState, useEffect, useCallback, useRef } from 'react';
import { simStudioApi } from '../api/simStudioApi';
import type { LiveFeedItem } from '../api/simStudioApi';

export function useLiveFeed(escolaId: string | null, pollMs = 5000) {
  const [feed, setFeed] = useState<LiveFeedItem[]>([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const knownIds = useRef<Set<string>>(new Set());

  const fetch = useCallback(async () => {
    if (!escolaId) return;
    try {
      const data = await simStudioApi.getLiveFeed(escolaId);
      // Mescla novos items no topo sem duplicar
      const novos = data.filter(item => !knownIds.current.has(item.id));
      if (novos.length > 0) {
        novos.forEach(i => knownIds.current.add(i.id));
        setFeed(prev => [...novos, ...prev].slice(0, 60));
      }
    } catch {
      // silencioso
    } finally {
      setLoading(false);
    }
  }, [escolaId]);

  useEffect(() => {
    if (!escolaId) { setFeed([]); knownIds.current.clear(); return; }
    setLoading(true);
    knownIds.current.clear();
    fetch();
    timerRef.current = setInterval(fetch, pollMs);
    return () => { if (timerRef.current) clearInterval(timerRef.current); };
  }, [escolaId, pollMs, fetch]);

  return { feed, loading };
}
